import { Box, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { stripeSelectedPaymentNames } from '../../../utils/stripeUtility';
import { stripePaymentTypes } from '../paymentMethodStripe/paymentTypes.constant';

const useStyles = makeStyles((theme) => ({
  nameOncardLabel: {
    fontWeight: 700,
    letterSpacing: '0.5px',
    fontSize: '18px',
    [theme.breakpoints.between('xs', 'md')]: {
      lineHeight: 1.43,
    },
  },
  imageContainer: {
    width: '20%',
    lineHeight: 0,
    [theme.breakpoints.between('xs', 'md')]: {
      lineHeight: 1.43,
    },
  },
  paymentContainer: {
    width: '100%',
    display: 'flex',
    padding: '15px',
    justifyContent: 'center',
  },
  paymentContainerInnerNode: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
  },
  applePaymentLogo: {
    width: '75%',
    height: '100%',
  },
}));

const StripePaymentMethodList = ({
  classes,
  cardTypeIcon,
  stripePaymentMethodType,
}) => {
  const paymentMethodListClasses = useStyles();
  const stripePaymentName = stripeSelectedPaymentNames[stripePaymentMethodType];
  const getStripePaymentMethodType = `${stripePaymentName}`;
  const logoClasses =
    stripePaymentMethodType === stripePaymentTypes.APPLE_PAY
      ? `${paymentMethodListClasses.applePaymentLogo}`
      : '';
  return (
    <Box className={paymentMethodListClasses.paymentContainer}>
      <Box className={paymentMethodListClasses.paymentContainerInnerNode}>
        <Box className={`${paymentMethodListClasses.imageContainer}`}>
          <img className={logoClasses} src={cardTypeIcon} alt="" />
        </Box>
        <Box alignSelf={'center'}>
          <Typography className={paymentMethodListClasses.nameOncardLabel}>
            {getStripePaymentMethodType}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default StripePaymentMethodList;
